import React from 'react';
import { MoreOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, MenuProps, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../../stores/auth.store';
import './ProfileDropdown.scss';
import { useTranslation } from '../../../i18n/i18n';
import { colors } from '../../../theme/colors';
import { signInPath } from '../../../routes';

const { Text } = Typography;

interface ProfileDropdownProps {
  email?: string;
  userName: string;
  collapsed: boolean;
}
const ProfileDropdown = ({ userName, email, collapsed }: ProfileDropdownProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'header' });
  const navigate = useNavigate();

  const handleLogout = () => {
    const authStore = useAuthStore.getState();
    authStore.logout();
    navigate(signInPath);
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: t('logout'),
      onClick: handleLogout,
    },
    {
      key: '2',
      label: <a href={'/dashboard/account'}>{t('goToAccount')}</a>,
    },
  ];

  return (
    <div className={'ProfileDropdown'}>
      <Dropdown menu={{ items }} placement={'topRight'} trigger={['click']}>
        <a onClick={(e) => e.preventDefault()} href={'/'}>
          <Space className={'ProfileDropdown__Space'}>
            <div className={'ProfileDropdown__data'}>
              <Avatar style={{ backgroundColor: colors.PRIMARY }}>{userName[0].toUpperCase()}</Avatar>
              {!collapsed && (
                <div className={'ProfileDropdown__userinfo'}>
                  <Text>{userName}</Text>
                </div>
              )}
            </div>
            {!collapsed && <MoreOutlined />}
          </Space>
        </a>
      </Dropdown>
    </div>
  );
};

export default ProfileDropdown;
